export default __webpack_public_path__ + "static/media/ladder-converted.036703c8.png";